export enum RadioColorEnum {
    Default = 'default',
    White = 'white'
}